export default "__VITE_ASSET__S_8Bjihr__"